import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex font-medium" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "text-center w-full font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ExpandCollapseTransition = _resolveComponent("ExpandCollapseTransition")!

  return (_openBlock(), _createElementBlock("table", {
    ref: _ctx.setTableElement,
    class: "w-full"
  }, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", {
        class: _normalizeClass(["flex gap-x-3 rounded text-[0.9rem] text-gray-500", [_ctx.narrow ? 'px-4' : 'px-6', _ctx.hasFocusedColumn ? 'mt-2' : 'my-2']])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
          return _renderSlot(_ctx.$slots, [`header_${header.value}`], {
            key: header.value,
            header: header,
            setItemRef: _ctx.setItemRef,
            getHeaderClass: _ctx.getHeaderClass,
            onHeaderClicked: _ctx.onHeaderClicked,
            getHeaderSortIcon: _ctx.getHeaderSortIcon
          }, () => [
            (_openBlock(), _createElementBlock("th", {
              key: header.value,
              ref_for: true,
              ref: (el) => _ctx.setItemRef(el as Element | null, header),
              class: _normalizeClass(["flex flex-1", [
                            `${_ctx.getHeaderClass(header, header.focusable || (header.sortable && _ctx.canSort))}`,
                            { 'rounded-lg text-white transition-colors min-h-10 px-3 py-2': header.focusable },
                            { 'bg-primary-700 hover:bg-primary-800': header.focusable && header.value !== _ctx.focusedColumn },
                            { 'bg-primary-800': header.value === _ctx.focusedColumn }
                        ]]),
              onClick: ($event: any) => (_ctx.onHeaderClicked(header))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", {
                  innerHTML: _ctx.sanitizeHtml(header.text)
                }, null, 8, _hoisted_3),
                (header.sortable && _ctx.canSort)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["sort-icon flex ml-1.5", { visible: _ctx.getHeaderSortIcon(header).active }])
                    }, [
                      _createVNode(_component_Icon, {
                        class: "my-auto min-w-2 w-2 h-3.5",
                        src: _ctx.getHeaderSortIcon(header).icon
                      }, null, 8, ["src"])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_1))
          ], true)
        }), 128))
      ], 2)
    ]),
    (_ctx.sortedItems?.length)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
          _renderSlot(_ctx.$slots, "prepend-rows", {
            getWidth: _ctx.getWidth,
            getItemProperty: _ctx.getItemProperty,
            getHeaderClass: _ctx.getHeaderClass,
            clickableItems: _ctx.clickableItems,
            focusedColumn: _ctx.focusedColumn
          }, undefined, true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedItems, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: _ctx.getRowKey(item, index)
            }, [
              _createElementVNode("tr", {
                class: _normalizeClass([[
                        { 'cursor-pointer': _ctx.clickableItems, 'odd:bg-dark-gray-200 rounded': !_ctx.expandItemsKey && !_ctx.rowClass?.(item), 'border-t border-dark-gray-300': _ctx.expandItemsKey },
                        _ctx.narrow ? 'px-4' : 'px-6',
                        _ctx.rowClass?.(item),
                    ], "flex py-4 gap-x-3 text-[0.9rem]"]),
                onClick: ($event: any) => (_ctx.clickableItems && _ctx.$emit('item-clicked', item))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                  return _renderSlot(_ctx.$slots, [`${header.value}`], {
                    key: `${_ctx.getRowKey(item, index)}_${header.value}`,
                    item: item,
                    getWidth: _ctx.getWidth,
                    getHeaderClass: _ctx.getHeaderClass,
                    header: header,
                    index: index,
                    getItemProperty: _ctx.getItemProperty,
                    expanded: _ctx.isExpanded(index)
                  }, () => [
                    (_openBlock(), _createElementBlock("td", {
                      key: `${_ctx.getRowKey(item, index)}_${header.value}`,
                      class: _normalizeClass([`${_ctx.getHeaderClass(header, _ctx.clickableItems)} ${header.cellClass ? header.cellClass : ''} break-words min-h-6.5`, { 'my-auto': header.value !== _ctx.focusedColumn, 'self-stretch -my-4 flex items-center bg-primary-700/20': header.value === _ctx.focusedColumn }]),
                      style: _normalizeStyle(`max-width: ${_ctx.getWidth(header)}px; width: 100%;`)
                    }, _toDisplayString(_ctx.getItemProperty(header, item, { numberFormat: header.numberFormat })), 7))
                  ], true)
                }), 128))
              ], 10, _hoisted_5),
              _createVNode(_component_ExpandCollapseTransition, null, {
                default: _withCtx(() => [
                  (_ctx.isExpanded(index) && item[_ctx.expandItemsKey]?.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["expand-container bg-dark-gray-200", { 'expand-container--last': index === _ctx.sortedItems.length - 1 }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[_ctx.expandItemsKey], (expandItem, expandItemIndex) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `expand_${_ctx.getRowKey(item, index)}_${expandItemIndex}`,
                            class: _normalizeClass(["flex py-4 gap-x-3 bg-dark-gray-200 text-[0.9rem]", [{ 'border-t border-dark-gray-400': expandItemIndex !== 0 }, _ctx.narrow ? 'px-4' : 'px-6']])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                              return _renderSlot(_ctx.$slots, [`${header.value}-expand`], {
                                key: `${_ctx.getRowKey(item, index)}_${header.value}`,
                                item: expandItem,
                                getWidth: _ctx.getWidth,
                                getHeaderClass: _ctx.getHeaderClass,
                                header: header,
                                index: index,
                                getItemProperty: _ctx.getItemProperty
                              }, () => [
                                (_openBlock(), _createElementBlock("td", {
                                  key: `${_ctx.getRowKey(item, index)}_${expandItemIndex}_${header.value}`,
                                  class: _normalizeClass([`${_ctx.getHeaderClass(header, _ctx.clickableItems)} break-words min-h-6.5`, { 'my-auto': header.value !== _ctx.focusedColumn, 'self-stretch -my-4 flex items-center bg-primary-700/20': header.value === _ctx.focusedColumn }]),
                                  style: _normalizeStyle(`max-width: ${_ctx.getWidth(header)}px; width: 100%;`)
                                }, _toDisplayString(_ctx.getItemProperty(header, expandItem, { numberFormat: header.numberFormat })), 7))
                              ], true)
                            }), 128))
                          ], 2))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_ExpandCollapseTransition, null, {
                default: _withCtx(() => [
                  (_ctx.isExpanded(index) && !_ctx.expandItemsKey)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["flex py-4 border-t border-b border-t-gray-200 border-b-gray-200", _ctx.narrow ? 'px-4' : 'px-6'])
                      }, [
                        _renderSlot(_ctx.$slots, "expanded-row", { item: item }, undefined, true)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ], 64))
          }), 128)),
          _renderSlot(_ctx.$slots, "append-rows", {
            getWidth: _ctx.getWidth,
            getItemProperty: _ctx.getItemProperty,
            getHeaderClass: _ctx.getHeaderClass,
            focusedColumn: _ctx.focusedColumn
          }, undefined, true)
        ]))
      : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
          _createElementVNode("tr", {
            class: _normalizeClass(["rounded flex py-4 gap-x-3 odd:bg-dark-gray-200", _ctx.narrow ? 'px-4' : 'px-6'])
          }, [
            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t('views.activityTable.table.emptyTableMessage')), 1)
          ], 2)
        ]))
  ], 512))
}